import { useCallback, useState } from "react";

export const useDateSelection = (initialDate: Date = new Date()) => {
  const [selectedDate, setSelectedDate] = useState<Date>(initialDate);

  const handleDateChange = useCallback((date: Date) => {
    setSelectedDate(date);
  }, []);

  return {
    selectedDate,
    handleDateChange,
  };
};
